<template>
<div class="chart-div">
    <!-- {{ chartdata }} -->
    <!-- <pie-chart :data="chartdata" :discrete="true" ytitle="Total Scores" :download="{ background: 'white', name: 'Testspace Users'}" xtitle="Attempts"></pie-chart> -->
    <column-chart :data="chartdata.graphdata" :ytitle="chartdata.ytitle" :xtitle="chartdata.xtitle" :download="{ background: 'white'  }" :min="0" min-height="600px"></column-chart>
</div>
</template>

<script>
// import {
//     mapState
// } from "vuex";

export default {
    props : ['chartdata'],
    created() {
    },
    data() {
        return {
        };
    },

    computed: {
        // ...mapState({
        //     gdata: state => state.dashboard.subjectgraph
        // })
    }
};
</script>

<style scoped>
.chart-div{
    background-color: white;
    border-radius: 10px 10px;
    padding: 6px;
}
</style>
